"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectHowToPayForProjectCard = void 0;
var vue_1 = require("vue");
var Button_1 = require("./common/Button");
var Card_1 = require("./card/Card");
var CardFinder_1 = require("../CardFinder");
var Tags_1 = require("../cards/Tags");
var CardOrderStorage_1 = require("./CardOrderStorage");
var PaymentWidgetMixin_1 = require("./PaymentWidgetMixin");
var PreferencesManager_1 = require("./PreferencesManager");
var TranslateMixin_1 = require("./TranslateMixin");
var TerraformingRatingAccounting_1 = require("../turmoil/TerraformingRatingAccounting");
var constants_1 = require("../constants");
exports.SelectHowToPayForProjectCard = vue_1.default.component('select-how-to-pay-for-project-card', {
    props: {
        player: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        var card;
        var cards = [];
        if (this.playerinput !== undefined &&
            this.playerinput.cards !== undefined &&
            this.playerinput.cards.length > 0) {
            cards = CardOrderStorage_1.CardOrderStorage.getOrdered(CardOrderStorage_1.CardOrderStorage.getCardOrder(this.player.id), this.playerinput.cards);
            card = cards[0];
        }
        if (card === undefined) {
            throw new Error('no card provided in player input');
        }
        return {
            cardName: card.name,
            card: card,
            cards: cards,
            cost: 0,
            tags: [],
            heat: 0,
            megaCredits: 0,
            steel: 0,
            titanium: 0,
            microbes: 0,
            floaters: 0,
            warning: undefined,
            availableSteel: 0,
            availableTitanium: 0,
        };
    },
    components: {
        Card: Card_1.Card,
        Button: Button_1.Button,
    },
    mixins: [PaymentWidgetMixin_1.PaymentWidgetMixin, TranslateMixin_1.TranslateMixin],
    mounted: function () {
        var app = this;
        vue_1.default.nextTick(function () {
            app.$data.card = app.getCard();
            app.$data.cost = app.$data.card.calculatedCost;
            app.$data.tags = app.getCardTags(),
                app.$data.megaCredits = app.getMegaCreditsMax();
            app.setDefaultValues();
        });
    },
    methods: {
        getCard: function () {
            var _this = this;
            var card = this.cards.find(function (c) { return c.name === _this.cardName; });
            if (card === undefined) {
                throw new Error("card not found " + this.cardName);
            }
            return card;
        },
        getCardTags: function () {
            var card = new CardFinder_1.CardFinder().getProjectCardByName(this.cardName);
            if (card === undefined) {
                throw new Error("card not found " + this.cardName);
            }
            return card.tags;
        },
        setDefaultValues: function () {
            this.microbes = 0;
            this.floaters = 0;
            this.steel = 0;
            this.titanium = 0;
            this.heat = 0;
            var megacreditBalance = Math.max(this.cost - this.player.megaCredits, 0);
            var deductUnits = function (availableUnits, unitValue, overpay) {
                if (overpay === void 0) { overpay = true; }
                if (availableUnits === undefined || availableUnits === 0) {
                    return 0;
                }
                var _tmp = megacreditBalance / unitValue;
                var balanceAsUnits = overpay ? Math.ceil(_tmp) : Math.floor(_tmp);
                var contributingUnits = Math.min(availableUnits, balanceAsUnits);
                megacreditBalance -= contributingUnits * unitValue;
                return contributingUnits;
            };
            var saveOverSpendingUnits = function (spendingUnits, unitValue) {
                if (spendingUnits === undefined || spendingUnits === 0 || megacreditBalance === 0) {
                    return 0;
                }
                var overSpendingAsUnits = Math.floor(Math.abs(megacreditBalance) / unitValue);
                var toSaveUnits = Math.min(spendingUnits, overSpendingAsUnits);
                megacreditBalance += toSaveUnits * unitValue;
                return toSaveUnits;
            };
            if (megacreditBalance > 0 && this.canUseMicrobes()) {
                this.microbes = deductUnits(this.playerinput.microbes, 2);
            }
            if (megacreditBalance > 0 && this.canUseFloaters()) {
                this.floaters = deductUnits(this.playerinput.floaters, 3);
            }
            this.availableSteel = Math.max(this.player.steel - this.card.reserveUnits.steel, 0);
            if (megacreditBalance > 0 && this.canUseSteel()) {
                this.steel = deductUnits(this.availableSteel, this.player.steelValue, true);
            }
            this.availableTitanium = Math.max(this.player.titanium - this.card.reserveUnits.titanium, 0);
            if (megacreditBalance > 0 && this.canUseTitanium()) {
                this.titanium = deductUnits(this.availableTitanium, this.player.titaniumValue, true);
            }
            if (megacreditBalance > 0 && this.canUseHeat()) {
                this.heat = deductUnits(this.player.heat, 1);
            }
            if (megacreditBalance < 0) {
                this.steel -= saveOverSpendingUnits(this.steel, this.player.steelValue);
                this.floaters -= saveOverSpendingUnits(this.floaters, 3);
                this.microbes -= saveOverSpendingUnits(this.microbes, 2);
                this.megaCredits -= saveOverSpendingUnits(this.megaCredits, 1);
            }
        },
        canUseHeat: function () {
            return this.playerinput.canUseHeat && this.player.heat > 0;
        },
        canUseSteel: function () {
            if (this.card !== undefined && this.availableSteel > 0) {
                if (this.tags.find(function (tag) { return tag === Tags_1.Tags.BUILDING; }) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseTitanium: function () {
            if (this.card !== undefined && this.availableTitanium > 0) {
                if (this.tags.find(function (tag) { return tag === Tags_1.Tags.SPACE; }) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseMicrobes: function () {
            if (this.card !== undefined && this.playerinput.microbes !== undefined && this.playerinput.microbes > 0) {
                if (this.tags.find(function (tag) { return tag === Tags_1.Tags.PLANT; }) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseFloaters: function () {
            if (this.card !== undefined && this.playerinput.floaters !== undefined && this.playerinput.floaters > 0) {
                if (this.tags.find(function (tag) { return tag === Tags_1.Tags.VENUS; }) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        cardChanged: function () {
            this.card = this.getCard();
            this.cost = this.card.calculatedCost || 0;
            this.tags = this.getCardTags();
            this.megaCredits = this.getMegaCreditsMax();
            this.setDefaultValues();
        },
        hasWarning: function () {
            return this.warning !== undefined;
        },
        hasCardWarning: function () {
            return this.card !== undefined && this.card.warning !== undefined;
        },
        hasRedsWarning: function () {
            if (this.playerinput.redsWarning !== true) {
                return false;
            }
            return this.card !== undefined && this.trGain() > 0;
        },
        trGain: function () {
            return TerraformingRatingAccounting_1.calculateTRGain(this.player, this.card.name);
        },
        redsPenalty: function () {
            return this.trGain() * constants_1.REDS_RULING_POLICY_COST;
        },
        showReserveSteelWarning: function () {
            var _a, _b;
            return ((_b = (_a = this.card) === null || _a === void 0 ? void 0 : _a.reserveUnits) === null || _b === void 0 ? void 0 : _b.steel) > 0 && this.canUseSteel();
        },
        showReserveTitaniumWarning: function () {
            var _a, _b;
            return ((_b = (_a = this.card) === null || _a === void 0 ? void 0 : _a.reserveUnits) === null || _b === void 0 ? void 0 : _b.titanium) > 0 && this.canUseTitanium();
        },
        saveData: function () {
            var htp = {
                heat: this.heat,
                megaCredits: this.megaCredits,
                steel: this.steel,
                titanium: this.titanium,
                microbes: this.microbes,
                floaters: this.floaters,
            };
            if (htp.megaCredits > this.player.megaCredits) {
                this.warning = 'You don\'t have that many M€';
                return;
            }
            if (this.playerinput.microbes !== undefined && htp.microbes > this.playerinput.microbes) {
                this.warning = 'You don\'t have enough microbes';
                return;
            }
            if (this.playerinput.floaters !== undefined && htp.floaters > this.playerinput.floaters) {
                this.warning = 'You don\'t have enough floaters';
                return;
            }
            if (htp.heat > this.player.heat) {
                this.warning = 'You don\'t have enough heat';
                return;
            }
            if (htp.titanium > this.player.titanium) {
                this.warning = 'You don\'t have enough titanium';
                return;
            }
            if (htp.steel > this.player.steel) {
                this.warning = 'You don\'t have enough steel';
                return;
            }
            var totalSpentAmt = (3 * htp.floaters) + (2 * htp.microbes) + htp.heat + htp.megaCredits + (htp.steel * this.player.steelValue) + (htp.titanium * this.player.titaniumValue);
            if (totalSpentAmt < this.cost) {
                this.warning = 'Haven\'t spent enough';
                return;
            }
            if (totalSpentAmt > this.cost) {
                var diff = totalSpentAmt - this.cost;
                if (htp.titanium && diff >= this.player.titaniumValue) {
                    this.warning = 'You cannot overspend titanium';
                    return;
                }
                if (htp.steel && diff >= this.player.steelValue) {
                    this.warning = 'You cannot overspend steel';
                    return;
                }
                if (htp.floaters && diff >= 3) {
                    this.warning = 'You cannot overspend floaters';
                    return;
                }
                if (htp.microbes && diff >= 2) {
                    this.warning = 'You cannot overspend microbes';
                    return;
                }
                if (htp.heat && diff >= 1) {
                    this.warning = 'You cannot overspend heat';
                    return;
                }
                if (htp.megaCredits && diff >= 1) {
                    this.warning = 'You cannot overspend megaCredits';
                    return;
                }
            }
            var showAlert = PreferencesManager_1.PreferencesManager.load('show_alerts') === '1';
            if (totalSpentAmt > this.cost && showAlert) {
                var diff = totalSpentAmt - this.cost;
                if (confirm('Warning: You are overpaying by ' + diff + ' M€')) {
                    this.onsave([[
                            this.card.name,
                            JSON.stringify(htp),
                        ]]);
                }
                else {
                    this.warning = 'Please adjust payment amount';
                    return;
                }
            }
            else {
                this.onsave([[
                        this.card.name,
                        JSON.stringify(htp),
                    ]]);
            }
        },
    },
    template: "<div class=\"payments_cont\">\n\n  <div v-if=\"showtitle === true\">{{ $t(playerinput.title) }}</div>\n\n  <label v-for=\"availableCard in cards\" class=\"payments_cards\">\n    <input class=\"hidden\" type=\"radio\" v-model=\"cardName\" v-on:change=\"cardChanged()\" :value=\"availableCard.name\" />\n    <Card class=\"cardbox\" :card=\"availableCard\" />\n  </label>\n\n  <section v-trim-whitespace>\n    <div v-if=\"hasCardWarning()\" class=\"card-warning\">{{ $t(card.warning) }}</div>\n    <div v-if=\"hasRedsWarning()\" class=\"card-warning\">\n      <div>Reds party is currently ruling.</div>\n      <div>You will lose {{ redsPenalty() }} mc if you play this card.</div>\n    </div>\n\n    <h3 class=\"payments_title\" v-i18n>How to pay?</h3>\n\n    <div class=\"payments_type input-group\" v-if=\"canUseSteel()\">\n      <i class=\"resource_icon resource_icon--steel payments_type_icon\" title=\"Pay by Steel\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('steel', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"steel\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('steel', 1, this.availableSteel)\" />\n      <Button type=\"max\" :onClick=\"_=>setMaxValue('steel', this.availableSteel)\" title=\"MAX\" />\n    </div>\n    <div v-if=\"showReserveSteelWarning()\" class=\"card-warning\" v-i18n>\n    (Some steel is unavailable here in reserve for the project card.)\n    </div>\n\n    <div class=\"payments_type input-group\" v-if=\"canUseTitanium()\">\n      <i class=\"resource_icon resource_icon--titanium payments_type_icon\" :title=\"$t('Pay by Titanium')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('titanium', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"titanium\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('titanium', 1, this.availableTitanium)\" />\n      <Button type=\"max\" :onClick=\"_=>setMaxValue('titanium', this.availableTitanium)\" title=\"MAX\" />\n    </div>\n    <div v-if=\"showReserveTitaniumWarning()\" class=\"card-warning\" v-i18n>\n    (Some titanium is unavailable here in reserve for the project card.)\n    </div>\n\n    <div class=\"payments_type input-group\" v-if=\"canUseHeat()\">\n      <i class=\"resource_icon resource_icon--heat payments_type_icon\" :title=\"$t('Pay by Heat')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('heat', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"heat\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('heat', 1)\" />\n      <Button type=\"max\" :onClick=\"_=>setMaxValue('heat')\" title=\"MAX\" />\n    </div>\n\n    <div class=\"payments_type input-group\" v-if=\"canUseMicrobes()\">\n      <i class=\"resource_icon resource_icon--microbe payments_type_icon\" :title=\"$t('Pay by Microbes')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('microbes', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"microbes\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('microbes', 1)\" />\n      <Button type=\"max\" :onClick=\"_=>setMaxValue('microbes')\" title=\"MAX\" />\n    </div>\n\n    <div class=\"payments_type input-group\" v-if=\"canUseFloaters()\">\n      <i class=\"resource_icon resource_icon--floater payments_type_icon\" :title=\"$t('Pay by Floaters')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('floaters', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"floaters\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('floaters', 1)\" />\n      <Button type=\"max\" :onClick=\"_=>setMaxValue('floaters')\" title=\"MAX\" />\n    </div>\n\n    <div class=\"payments_type input-group\">\n      <i class=\"resource_icon resource_icon--megacredits payments_type_icon\" :title=\"$t('Pay by Megacredits')\"></i>\n      <Button type=\"minus\" :onClick=\"_=>reduceValue('megaCredits', 1)\" />\n      <input class=\"form-input form-inline payments_input\" v-model.number=\"megaCredits\" />\n      <Button type=\"plus\" :onClick=\"_=>addValue('megaCredits', 1)\" />\n    </div>\n\n    <div v-if=\"hasWarning()\" class=\"tm-warning\">\n      <label class=\"label label-error\">{{ $t(warning) }}</label>\n    </div>\n\n    <div v-if=\"showsave === true\">\n      <Button type=\"submit\" :onClick=\"saveData\" :title=\"playerinput.buttonLabel\" :danger=\"hasRedsWarning()\" />\n    </div>\n  </section>\n</div>",
});
//# sourceMappingURL=SelectHowToPayForProjectCard.js.map